module.exports = __webpack_public_path__ + "r.no1.017e71ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/r.no1.jpg
// module id = 29uj
// module chunks = 0